import Text from "../../../../../shared/components/Text";
import { Box, useTheme } from "@material-ui/core";
import React from "react";
import { PaymentPlanProgress } from "./components/PaymentPlanProgress";
import { PaymentPlanLines } from "./components/PaymentPlanLines";
import { assetIds, ThemedAsset } from "nemuru-components";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import IconTitle from "../../../../../shared/components/IconTitle";
import MainButton from "../../../../../shared/components/MainButton";

export const PaymentPlan = ({
  paymentPlan,
  currentPaymentPlanLine,
  onPrev,
}) => {
  const { palette } = useTheme();
  return (
    <>
      <Box
        className={"appear-anim"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Box my={1}>
          <IconTitle
            title={<Text tId={"YOUR_PAYMENT_PLAN"} />}
            icon={
              <ThemedAsset
                id={assetIds.ICON_LOAN}
                width={ICON_TITLE_HEIGHT}
                height={ICON_TITLE_HEIGHT}
                style={{ color: palette.secondary.main }}
              />
            }
          />
        </Box>
        <Box width={"100%"}>
          <PaymentPlanProgress
            paymentPlan={paymentPlan}
            currentPaymentPlanLine={currentPaymentPlanLine}
          />
          <PaymentPlanLines
            paymentPlan={paymentPlan}
            currentPaymentPlanLine={currentPaymentPlanLine}
          />
        </Box>
      </Box>
      <MainButton disabled={!onPrev} onClick={onPrev} variant={"text"}>
        <Text tId={"BACK"} />
      </MainButton>
    </>
  );
};
